import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { TreatmentPlanViewType } from '@principle-theorem/principle-core/interfaces';
import { getEnumValues } from '@principle-theorem/shared';

type TreatmentPlanViewTypeOption = {
  value: TreatmentPlanViewType;
  label: string;
};

const VIEW_TYPE_LABELS: Record<TreatmentPlanViewType, string> = {
  [TreatmentPlanViewType.TreatmentPlan]: 'Treatment Plan',
  [TreatmentPlanViewType.AllTreatments]: 'All Treatments',
  [TreatmentPlanViewType.ComparePlans]: 'Compare Plans',
};

@Component({
  selector: 'pr-treatment-plan-view-type-selector',
  templateUrl: './treatment-plan-view-type-selector.component.html',
  styleUrls: ['./treatment-plan-view-type-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatSelectModule],
})
export class TreatmentPlanViewTypeSelectorComponent {
  activeType = input.required<TreatmentPlanViewType>();
  typeSelected = output<TreatmentPlanViewType>();
  typeFilters: TreatmentPlanViewTypeOption[] = getEnumValues(
    TreatmentPlanViewType
  ).map((value) => ({
    value,
    label: VIEW_TYPE_LABELS[value],
  }));
}
